module.exports = "<p>Loading ...</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/redirect-locale/redirect-locale.component.html
// module id = ./src/app/redirect-locale/redirect-locale.component.html
// module chunks = main